<div class="dialog-container">
  <div class="dialog-dismiss" (click)="onRejectAction()">
    <img src="assets/plan/back-gray.svg" />
  </div>
  <img class="dialog-img" src="assets/profile/referral-banner.png" />
  <div class="dialog-title">دعوت دوستان</div>
  <div class="dialog-description">
    شما به دعوت دوستتان به بنتو پیوستید. ۱ هفته اشتراک رایگان دارید.
  </div>
  <div class="dialog-button" (click)="onAcceptAction()">
    برنامه غذایی دریافت کنید
  </div>
</div>
